/**
 * Отдельный vuex модуль для взаимодействия по schedules/-API
 */


// actions для schedules. Вызов действия начинать с "schedule/"
export const ACTION_LOAD_SCHEDULES_LIST = "LOAD_SCHEDULES_LIST";
export const ACTION_CREATE_SCHEDULE = "CREATE_SCHEDULE";
export const ACTION_EDIT_SCHEDULE = "EDIT_SCHEDULE";
export const ACTION_DELETE_SCHEDULE = "DELETE_SCHEDULE";

/**
 * Дни недели.
 *
 */
export const DAYS_OF_WEEK = Object.freeze([
  {label: 'ПН', value: 0},
  {label: 'ВТ', value: 1},
  {label: 'СР', value: 2},
  {label: 'ЧТ', value: 3},
  {label: 'ПТ', value: 4},
  {label: 'СБ', value: 5},
  {label: 'ВС', value: 6},
]);
/**
 * Подготовка данных для работы с расписанием.
 *
 */
function prepareSchedulePayload({scheduleType, cameraNumber, schedule, scheduleId = null}) {
  const labelToDay = DAYS_OF_WEEK.reduce((acc, day) => {
    acc[day.label] = day.value;
    return acc;
  }, {});
  const settings = schedule.days
    .map(label => ({
      day_of_week: labelToDay[label],
      start_time: schedule.from,
      end_time: schedule.to,
      is_active: true
    }))
    .filter(item => item.day_of_week !== undefined);

  return {
    ...(scheduleId && {schedule_id: scheduleId}),
    schedule_type: scheduleType,
    camera_number: cameraNumber,
    settings
  };
}
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    /**
     * Загрузка списка расписаний.
     *
     * @param {Array.<String>} camerasNumber
     * @param {Array.<String>} scheduleType
     */
    async [ACTION_LOAD_SCHEDULES_LIST](context, [cameraNumber, scheduleType]) {
      try {
        const response = await this.getters.ajaxClient.post("/v0/schedule/", {
          schedule_type: scheduleType,
          camera_number: cameraNumber
        });
        return response.data;
      } catch {
        return [];
      }
    },
    /**
     * Удаление расписания.
     *
     */
    async [ACTION_DELETE_SCHEDULE](context, [scheduleId]) {
      try {
        await this.getters.ajaxClient.post("/v0/schedule/delete", {
          schedule_id: scheduleId,
          confirm: true // sic
        });
      } catch {
        return [];
      }
    },
    /**
     * Редактирование экземпляра расписания.
     *
     * @param {Array.<String>} camerasNumber
     * @param {Array.<String>} scheduleType
     */
    async [ACTION_EDIT_SCHEDULE](context, {cameraNumber, scheduleType, schedule, scheduleId}) {
      try {
        const payload = prepareSchedulePayload({
          scheduleType, cameraNumber, schedule, scheduleId
        });
        const response = await this.getters.ajaxClient.post("/v0/schedule/edit/", payload);
        return response;
      } catch (e) {
        console.error("Ошибка при редактировании расписания:", e);
        throw e;
      }
    },
    /**
     * Создание экземпляра расписания.
     *
     * @param {Array.<String>} cameraNumber
     * @param {Array.<String>} scheduleType
     */
    async [ACTION_CREATE_SCHEDULE](context, {cameraNumber, scheduleType, schedule}) {
      try {
        const payload = prepareSchedulePayload({scheduleType, cameraNumber, schedule});
        const response = await this.getters.ajaxClient.post("/v0/schedule/create/", payload);
        return response;
      } catch (e) {
        console.error("Ошибка при создании расписания:", e);
        throw e;
      }
    }
  },
};
